import { SimInventoryFiltersV2 } from 'simInventory/models/SimProfile.model';
import { Sorting } from 'src/common/components/Filters/constants/sorting';
import { SESSION_LIST_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionListDetails';
import { SESSION_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionsDetails';

type SimProductsFiltersWithSorting = SimInventoryFiltersV2 & {
  sorting: { columnName: string; sort: Sorting } | null;
};

type SimProductsFiltersWithSortingAndPagination = SimProductsFiltersWithSorting & {
  page?: number;
  rowsPerPage?: number;
};

const prepareFilterKey = ({
  sorting,
  customFields = {},
  tags,
  ...otherFilters
}: SimProductsFiltersWithSortingAndPagination) => {
  const sortingFilter = sorting || {};
  return {
    ...sortingFilter,
    ...customFields,
    tags: tags ? [...tags].sort((a, b) => a.localeCompare(b)) : null,
    ...otherFilters,
  };
};

export const simProductsQueries = {
  all: ['SimProductsConfigurable'],
  lists: () => [...simProductsQueries.all, 'List'],
  list: (filters: SimProductsFiltersWithSortingAndPagination) => [
    ...simProductsQueries.lists(),
    prepareFilterKey(filters),
  ],
  pagination: (filters: SimProductsFiltersWithSorting) => {
    return [...simProductsQueries.all, 'Pagination', prepareFilterKey(filters)];
  },
  export: (filters: SimProductsFiltersWithSorting) => {
    return [...simProductsQueries.list(filters), 'Export'];
  },
  configuration: () => [...simProductsQueries.all, 'configuration'],
  sessionDetails: (imsis?: string[]) => [
    ...simProductsQueries.all,
    SESSION_DETAILS_QUERY_KEY,
    imsis,
  ],
  sessionListDetails: (imsis?: string[]) => [
    ...simProductsQueries.all,
    SESSION_LIST_DETAILS_QUERY_KEY,
    imsis,
  ],
  availableActions: (filters: { iccids: string[] }) => [
    ...simProductsQueries.all,
    'availableActions',
    filters,
  ],
};
